const investmentTableLang = {
	vintage: {
		tag: 'investment.table.vintage',
		fr: 'Millésime',
		en: 'Vintage',
	},
	status: {
		tag: 'investment.table.status',
		fr: 'Statut',
		en: 'Status',
	},
	realized: {
		tag: 'investment.table.realized',
		fr: 'Réalisé',
		en: 'Realized',
	},
	realized_yes: {
		tag: 'investment.table.realized_yes',
		fr: 'Oui',
		en: 'Yes',
	},
	realized_no: {
		tag: 'investment.table.realized_no',
		fr: 'Non',
		en: 'No',
	},
	sfdr: {
		tag: 'investment.table.sfdr',
		fr: 'SFDR',
		en: 'SFDR',
	},
	investment_year: {
		tag: 'investment.table.investment_year',
		fr: 'Souscription',
		en: 'Invest. y',
	},
	domain: {
		tag: 'investment.table.domain',
		fr: 'Domaine',
		en: 'Domain',
	},
	group: {
		tag: 'investment.table.group',
		fr: 'Groupe',
		en: 'Group',
	},
	investor: {
		tag: 'investment.table.investor',
		fr: 'Canton',
		en: 'Sub portfolio',
	},
	fund: {
		tag: 'investment.table.fund',
		fr: 'Fonds',
		en: 'Fund',
	},
	fund_type: {
		tag: 'investment.table.fund_type',
		fr: 'Type de fonds',
		en: 'Fund type',
	},
	committed_capital: {
		tag: 'investment.table.committed_capital',
		fr: 'Engagé',
		en: 'Committed',
	},
	called_capital: {
		tag: 'investment.table.called_capital',
		fr: 'Appelé',
		en: 'Called',
	},
	callable_capital: {
		tag: 'investment.table.callable_capital',
		fr: 'Capital appelable',
		en: 'Uncalled capital',
	},
	total_distributed: {
		tag: 'investment.table.total_distributed',
		fr: 'Total distribué',
		en: 'Total distributed',
	},
	total_distributed_minus_interest_income: {
		tag: 'investment.table.total_distributed_minus_interest_income',
		fr: "Total distribué - Revenus d'intérêts",
		en: 'Total distributed - Interest income',
	},
	total_distributed_minus_return_of_capital: {
		tag: 'investment.table.total_distributed_minus_return_of_capital',
		fr: 'Total distribué - Remboursement de capital',
		en: 'Total distributed - Return of capital',
	},
	net_called_capital: {
		tag: 'investment.table.net_called_capital',
		fr: 'Capital net appelé',
		en: 'Capital at work',
	},
	net_asset_value: {
		tag: 'investment.table.net_asset_value',
		fr: 'NAV',
		en: 'NAV',
	},
	outstanding_capital: {
		tag: 'investment.table.outstanding_capital',
		fr: 'Capital restant dû',
		en: 'Outstanding capital',
	},
	irr: {
		tag: 'investment.table.irr',
		fr: 'TRI',
		en: 'IRR',
	},
	arr: {
		tag: 'investment.table.arr',
		fr: 'ARR',
		en: 'ARR',
	},
	dpi: {
		tag: 'investment.table.dpi',
		fr: 'DPI',
		en: 'DPI',
	},
	rvpi: {
		tag: 'investment.table.rvpi',
		fr: 'RVPI',
		en: 'RVPI',
	},
	percent_owned: {
		tag: 'investment.table.percent_owned',
		fr: 'Emprise',
		en: 'Fund owned',
	},
	percent_owned_tooltip: {
		tag: 'investment.table.percent_owned_tooltip',
		fr: 'Pourcentage du fonds détenu par le canton/portefeuille',
		en: 'Percentage of the fund owned by the sub portfolio',
	},
	percent_owned_for_export: {
		tag: 'investment.table.percent_owned_for_export',
		fr: '% du fonds possédé',
		en: '% of found owned',
	},
	total_value: {
		tag: 'investment.table.total_value',
		fr: 'Valeur totale',
		en: 'Total value',
	},
	nav_calc: {
		tag: 'investment.table.nav_calc',
		fr: 'Nav calc.',
		en: 'Nav calc.',
	},
	reporting_period: {
		tag: 'investment.table.reporting_period',
		fr: 'Période de reporting',
		en: 'Reporting period',
	},
	fund_currency: {
		tag: 'investment.table.fund_currency',
		fr: 'Devise du fonds',
		en: 'Fund currency',
	},
	date: {
		tag: 'investment.table.date',
		fr: 'Date',
		en: 'Date',
	},
	year: {
		tag: 'investment.table.year',
		fr: 'Année',
		en: 'Year',
	},
	data_type: {
		tag: 'investment.table.data_type',
		fr: 'Type de données',
		en: 'Data type',
	},
	values: {
		tag: 'investment.table.values',
		fr: 'Valeurs',
		en: 'Values',
	},
};

export default investmentTableLang;
